import type { GetNumberOfCommits } from './types'

export const getNumberOfCommits = (infoData: GetNumberOfCommits) =>
  infoData.number_commits ? ` (${infoData.number_commits})` : ''
